import imamrezaLogo from '@assets/images/logo.png';
import {ProjectContext} from '@context/ProjectContext';
// @ts-ignore
import banner from '@icons/banner-dark.png';
import {Typography, useTheme} from '@mui/material';
import {useContext} from 'react';
import {Link} from 'react-router-dom';
import PersianDate from './PersianDate';

export default function CalendarBox() {
	const context = useContext(ProjectContext);
	const theme = useTheme();
	const date = new PersianDate();
	const background: string = context.shahadat ?
		`url(${banner}) no-repeat center/cover`
		// `url("https://files.novinrazavi.ir/competition/37e9e4da-261a-4f15-999c-e04df54fb353.jpg") no-repeat center/cover`
		:
		// @ts-ignore
		`linear-gradient(267.1deg, ${theme.palette.primary[400]} 2.03%, ${theme.palette.primary[600]} 100%)`;
		// `linear-gradient(267.1deg, ${theme.palette.primary[100]} 2.03%, ${theme.palette.primary[300]} 100%)`;
	return (
		<Link
			to="/calendar"
			style={{background, backgroundColor: context.shahadat ? 'black' : ''}}
			// style={{backgroundColor: context.shahadat ? 'black' : ''}}
			// className="flex flex-row justify-between items-center px-2 mx-4 h-20 rounded text-[#664504] object-contain">
			className="flex flex-row justify-between items-center px-2 mx-4 h-20 rounded text-white object-contain">
			<div className="flex flex-row items-center">
				<Typography sx={{color: context.shahadat ? 'error.400' : 'none'}}
				            className="text-5xl mx-2 mt-3">{date.getDate()}</Typography>
				<div className="flex flex-col">
					<Typography>{date.getDayName()}</Typography>
					<Typography>{date.getMonthName()} {date.getYear()}</Typography>
				</div>
			</div>
			<div>
				<img src={imamrezaLogo} alt={'imamreza'} className={'w-[60px] h-fit'}/>
			</div>
			<div className="flex flex-col mx-3">
				{/*<Typography>{date.toLocaleDateString('ar-SA', {year: 'numeric', month: 'long', day: 'numeric'})}</Typography>*/}
				<Typography>{date.getHijriDate({year: 'numeric', month: 'long', day: 'numeric'})}</Typography>
				<Typography>{date.toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'})}</Typography>
			</div>
		</Link>
	);
}
